import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Index from "@/components/index.vue"
import About from "@/components/about.vue"
import Core from "@/components/core.vue"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },{
      path:"/about",
      name:"about",
      component:About
    },{
      path:"/core",
      name:"core",
      component:Core
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js